export default "__VITE_ASSET__cW8aeHlG__"